const enum difficulty {
    EASY = 'easy',
    MEDIUM = 'medium',
    HARD = 'hard',
    EXPERT = 'expert',
    RANDOM = 'Random',
    CONTINUE = 'Continue',
    NONE = 'None'
}

export default difficulty;